var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenCategoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.07812 10.3385H6.74479C8.41146 10.3385 9.24479 9.50521 9.24479 7.83854V6.17187C9.24479 4.50521 8.41146 3.67188 6.74479 3.67188H5.07812C3.41146 3.67188 2.57812 4.50521 2.57812 6.17187V7.83854C2.57812 9.50521 3.41146 10.3385 5.07812 10.3385Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0781 10.3385H16.7448C18.4115 10.3385 19.2448 9.50521 19.2448 7.83854V6.17187C19.2448 4.50521 18.4115 3.67188 16.7448 3.67188H15.0781C13.4115 3.67188 12.5781 4.50521 12.5781 6.17187V7.83854C12.5781 9.50521 13.4115 10.3385 15.0781 10.3385Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0781 20.3385H16.7448C18.4115 20.3385 19.2448 19.5052 19.2448 17.8385V16.1719C19.2448 14.5052 18.4115 13.6719 16.7448 13.6719H15.0781C13.4115 13.6719 12.5781 14.5052 12.5781 16.1719V17.8385C12.5781 19.5052 13.4115 20.3385 15.0781 20.3385Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.07812 20.3385H6.74479C8.41146 20.3385 9.24479 19.5052 9.24479 17.8385V16.1719C9.24479 14.5052 8.41146 13.6719 6.74479 13.6719H5.07812C3.41146 13.6719 2.57812 14.5052 2.57812 16.1719V17.8385C2.57812 19.5052 3.41146 20.3385 5.07812 20.3385Z",
    stroke: "#50C878",
    strokeWidth: 0.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenCategoryIcon);
export default __webpack_public_path__ + "static/media/GreenCategoryIcon.ec89e46033a37a3dbdbe7ae59487f6e9.svg";
export { ForwardRef as ReactComponent };